import React, { useEffect, useState } from "react";

//MUI
import { Drawer } from "@mui/material";
import PaidInvoicesMatch from "./PaidInvoicesMatch";
import { useEndCustomerPaid } from "Context/EndCustomerPaid";
import { usePopupNotificationContext } from "Context/NotificationPopup";
import SearchModal from "Pages/AdminInterface/dashboard/Components/SearchModal";

export default function PaidInvoiceWorkflow() {
  const { selectedInvoice, setSelectedInvoiceId, matchPaymentToInvoice } =
    useEndCustomerPaid();
  const [openSearchModal, setOpenSearchModal] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [initialSearchTerm, setInitialSearchTerm] = useState(null);
  const { openError } = usePopupNotificationContext();

  const onSearchOpen = (searchTerm) => {
    setOpenDrawer(false);
    setInitialSearchTerm(searchTerm);
    setTimeout(() => setOpenSearchModal(true), 150);
  };

  const onSearchClose = () => {
    setOpenSearchModal(false);
    setTimeout(() => setOpenDrawer(true), 150);
  };

  const onSearchSelect = async (invoiceId) => {
    const res = await matchPaymentToInvoice(selectedInvoice.Id, invoiceId);
    if (res && !res.data.Data) {
      openError(res.data.Message, 3000);
    } else {
      setOpenSearchModal(false);
      setTimeout(() => setOpenDrawer(true), 150);
    }
  };

  useEffect(() => {
    if (selectedInvoice) {
      setOpenDrawer(true);
    } else {
      setOpenDrawer(false);
    }
  }, [selectedInvoice]);

  return (
    <>
      <Drawer
        anchor="bottom"
        open={openDrawer}
        onClose={() => {
          if (!openSearchModal) {
            setSelectedInvoiceId(null);
          }
          setOpenDrawer(false);
        }}
        onClick={(e) => e.stopPropagation()}
        sx={{ "& .MuiPaper-root": { overflow: "hidden" } }} //Remove double scrollbar
      >
        <PaidInvoicesMatch
          onSearch={(searchTerm) => onSearchOpen(searchTerm)}
        />
      </Drawer>

      {openSearchModal ? (
        <SearchModal
          onClose={onSearchClose}
          open={openSearchModal}
          onSelect={onSearchSelect}
          initialSearchTerm={initialSearchTerm}
          isMatchingView={true}
        />
      ) : null}
    </>
  );
}
